function homeTitle() {
  return process.env.VUE_APP_TITLE ? process.env.VUE_APP_TITLE : 'Home';
}

const state = {
  crumbs: [
    {
      name: 'index',
      label: homeTitle(),
    },
  ],
};

// getters
const getters = {};

// actions
const actions = {
  add({ commit }, crumb) {
    commit('add', crumb);
  },
  set({ commit }, input) {
    const crumbs = [
      {
        name: 'index',
        label: homeTitle(),
      },
    ].concat(input);
    commit('set', {
      crumbs,
    });
  },
  reset({ commit }) {
    const crumbs = [
      {
        name: 'index',
        label: homeTitle(),
      },
    ];
    commit('set', {
      crumbs,
    });
  },
};

// mutations
const mutations = {
  add(state, { crumb }) {
    state.crumbs.push(crumb);
  },
  set(state, { crumbs }) {
    state.crumbs = crumbs;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
